import { useEffect, useState, useMemo } from 'react';
import Modal from '../Modal';
import Select from 'react-select';

const BannerQueueModal = (props) => {
  const {api, bannerQueueModalIsVisible, setBannerQueueModalIsVisible ,loading } = props;
  const [savedIds, setSavedIds] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      await api.getBannerQueue(setBannerQueueModalIsVisible)
      .then(res => {
        if(res && res.data) {
          const sortedLabels = extractLabels(res.data)
          sortedLabels && setSavedIds(sortedLabels)
        }
      })
    }
    
    fetchData()
  }, [])

  const extractLabels = (data) => {
    const result = {};
  
    for (const box in data) {
      if (Array.isArray(data[box])) {
        result[box] = data[box].map(item => ({ label: item.title }));
      }
    }
  
    return result;
  };

  const renderModalBody = () => {
    return (
      <>
        {
          <form className="form-container">
            <div className="queue">
              <div className="form-row">
                <label className="label">Box 1</label>
                <Select
                  isMulti
                  name="queue-box3"
                  value={savedIds.box1 || []}
                  classNamePrefix="select"
                  isClearable= {false}
                  isDisabled={true}
                  isSearchable={false}
                  components={{
                    DropdownIndicator: () => null, // Rimuove la freccia
                    ClearIndicator: () => null,
                    MultiValueRemove: () => null
                  }}
                  styles={{
                    clearIndicator: (provided) => ({
                      ...provided,
                      display: 'none'  // Nasconde l'icona 'x'
                    })
                  }}
              />
              </div>
              <div className="form-row">
                <label className="label">Box 2</label>
                <Select
                  isMulti
                  name="queue-box2"
                  value={savedIds.box2}
                  options={[]}
                  classNamePrefix="select"
                  isClearable= {false}
                  isDisabled={true}
                  isSearchable={false}
                  components={{
                    DropdownIndicator: () => null, // Rimuove la freccia
                    ClearIndicator: () => null,
                    MultiValueRemove: () => null
                  }}
                />
              </div>
              <div className="form-row">
                <label className="label">Box 3</label>
                <Select
                  isMulti
                  name="queue-box3"
                  value={savedIds.box3}
                  options={[]}
                  classNamePrefix="select"
                  isClearable= {false}
                  isDisabled={true}
                  isSearchable={false}
                  components={{
                    DropdownIndicator: () => null, // Rimuove la freccia
                    ClearIndicator: () => null,
                    MultiValueRemove: () => null
                  }}
                />
              </div>
            </div>
          </form>
        }
      </>
    )
  }

  const renderModalFooter = () => (
    <div className="button-container">
      <button className="button button--primary"
        onClick={()=>setBannerQueueModalIsVisible(false)}
      >
        Ok, ho capito
      </button>
    </div>
  )

  return (
    <>
    {
      !loading ?
        <Modal
          visible={bannerQueueModalIsVisible}
          title={'Gestisci Banner'}
        >
          {renderModalBody()}
          {renderModalFooter()}
        </Modal>
      :
      <></>
    }
    </>
  );
};

export default BannerQueueModal;
